
<div class="float-left">
    <p class="mb-1">
        {{ $tc("supplierDetail.concurrency.table.data.tenders", number) }}<br>
        <span class="concurrency_price" v-if="false">{{ price_number|price }}</span>
    </p>
    <ConcurrencyCircles :color="color" :number="number"/>
</div>
